import * as React from 'react'

const SESSION_STORAGE_KEY = 'childPageVisited'

export function useTrackChildPageVisit() {
  React.useEffect(() => {
    // Set flag in sessionStorage to indicate user visited a child page
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
  }, [])
}
